<template>
  <div class="no-data" :class="[`type${type}`]">
    <img class="no-data-icon" :src="require(`../assets/no_data${type}.png`)" alt="">
    <p v-if="type === '2'" class="no-data-info">您选择的航次尚未开放岸上观光行程，<br>我们将于行程开放后以短信形式通知您，<br>请密切关注皇家行前订</p>
    <p v-else class="no-data-info">活动暂未上线，敬请期待<br />更多丰富船上娱乐餐饮活动等您参加</p>
  </div>
</template>

<script>
export default {
  name: 'NoData',

  props: {
    type: {
      type: String,
      default: '1'
    }
  }
}
</script>

<style lang="less" scoped>
.no-data {
  padding: 110px 0 116px;
  text-align: center;
  font-size: 24px;
  color: #999;
  line-height: 40px;
  &.type2 {
    .no-data-icon {
      width: 216px;
    }
  }
  .no-data-icon {
    display: block;
    width: 116px;
    margin: 0 auto;
  }
  .no-data-info {
    margin-top: 34px;
  }
}
</style>
